import Vue from 'vue';

//import app from "../vue/app.vue";
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: () => import('../vue/home.vue')
        },
    ]
});

var app = require("../vue/app.vue").default;
new Vue({
    el: '#app',
    router,
    render: h => h(app),

})
